// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
// COMPONENTS
import Select from 'react-select'
import { Form, Spinner, Modal, Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import BlockUi from 'react-block-ui';
import Flatpickr from "react-flatpickr";
import DateFilterComponent from "../../components/DateFilterComponent";
//SERVICES AND HELPERS
import * as alert from '../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../redux/confirmModalRedux';
import * as userService from '../../../services/management/userService';
import * as helper from '../../../helpers/helper';

const TimeSheetPage = (props) => {
    const { auth, showAlert } = props;
    const [loading, setLoading] = useState(false);
    const [dateOption, setDateOption] = useState({
        startDate: null,
        endDate: null
    });
    const [timeSheet, setTimeSheet] = useState([]);

    const clearFilter = () => {
        setDateOption({
            startDate: null,
            endDate: null
        });
        setTimeSheet([]);
    }

    const getMyTimeSheet = () => {
        setLoading(true);

        userService.getMyTimeSheet(dateOption).then(res => {
            setTimeSheet(res);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => setLoading(false))
    }

    const columns = [
        {
            name: "clockIn",
            label: "Date",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customFilterListRender: v => helper.dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return helper.dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Clock In"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                },
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(timeSheet[dataIndex].clockIn).format("MM/DD/YYYY")}</p>
                    );
                }
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: "jobNumber",
            label: "Job#",
            options: {
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: "clockIn",
            label: "ClockIn",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customFilterListRender: v => helper.dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return helper.dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Clock In"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                },
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(timeSheet[dataIndex].clockIn).format("HH:mm, MM/DD/YYYY")}</p>
                    );
                }
            }
        },
        {
            name: "clockOut",
            label: "Clock Out",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customFilterListRender: v => helper.dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return helper.dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Clock Out"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                },
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(timeSheet[dataIndex].clockOut).format("HH:mm, MM/DD/YYYY")}</p>
                    );
                }
            }
        },
        {
            name: "hoursWorked",
            label: "Hours Worked",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    if (timeSheet[dataIndex].clockOut) {
                        var duration = moment.duration(moment(timeSheet[dataIndex].clockOut).diff(timeSheet[dataIndex].clockIn));

                        // duration in hours
                        var hours = parseInt(duration.asHours());

                        // duration in minutes
                        var minutes = parseInt(duration.asMinutes()) % 60;

                        return (
                            <p>{hours + ' hour and ' + minutes + ' minutes'}</p>
                        );
                    }

                    return <p>-</p>
                }
            }
        },
        // {
        //     name: "cost",
        //     label: "Amount",
        //     options: {
        //         filter: true,
        //         filterType: 'multiselect',
        //         sort: true,
        //         customBodyRenderLite: (dataIndex) => {
        //             return (
        //                 <p>${(timeSheet[dataIndex].cost).toFixed(2)}</p>
        //             );
        //         }
        //     }
        // },
    ];

    return (
        <div className="card card-custom" >
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        Time Sheet
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        View Your TimeSheet
                    </span>
                </div>
                <div className="card-toolbar">
                    <Link
                        to="/"
                        className="btn btn-secondary"
                    >
                        Cancel
                    </Link>
                </div>
            </div>
            <BlockUi tag="div" blocking={loading}>
                <div className="row">
                    <div className="card-body">
                        <div className="form">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Start Date
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Flatpickr
                                        placeholder="MM/DD/YYYY"
                                        options={{
                                            enableTime: false,
                                            dateFormat: "m/d/Y",
                                        }}
                                        value={moment(dateOption.startDate).format("MM/DD/YYYY")}
                                        onChange={date => {
                                            setDateOption({ ...dateOption, startDate: date[0] })
                                        }}
                                        className="form-control form-control-lg form-control-solid"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    End Date
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Flatpickr
                                        placeholder="MM/DD/YYYY"
                                        options={{
                                            enableTime: false,
                                            dateFormat: "m/d/Y",
                                            minDate: dateOption.startDate
                                        }}
                                        value={moment(dateOption.endDate).format("MM/DD/YYYY")}
                                        onChange={date => {
                                            setDateOption({ ...dateOption, endDate: date[0] })
                                        }}
                                        className="form-control form-control-lg form-control-solid"
                                    />
                                </div>
                            </div>

                            <div className="row col-lg-12 col-xl-12 search-clear-btn-group mt-lg-5 flex-row mb-lg-10" style={{ justifyContent: 'flex-end' }}>
                                <button
                                    className="btn btn-primary font-weight-bolder font-size-sm mr-3"
                                    onClick={getMyTimeSheet}
                                >
                                    View TimeSheet
                                </button>{' '}
                                <button className="btn btn-secondary font-weight-bolder font-size-sm mr-3" onClick={clearFilter}>
                                    Clear
                                </button>
                            </div>
                        </div>
                        <MUIDataTable
                            data={timeSheet}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                downloadOptions: {
                                    filename: 'User_Credentials.csv',
                                    filterOptions: {
                                        useDisplayedColumnsOnly: true,
                                        useDisplayedRowsOnly: true
                                    }
                                },
                                textLabels: {
                                    body: {
                                        noMatch: loading ?
                                            <Spinner animation="border" size="lg" variant="info" /> :
                                            'Sorry, no matching records found.',
                                    },
                                }
                            }}
                        />
                    </div>
                </div>
            </BlockUi>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(TimeSheetPage);